import React, { useState } from 'react';
import { IconDownload, IconPlus } from '../../../common/icons';
import Pagination from '../../../common/pagination/index';
import SubHeader from '../common-elements/SubHeader';
import AddCommodityProfile from './elements/AddCommodityProfile';
import StaticTableContent from './elements/StaticTableContent';
import SettingsTab from '../common-elements/SettingsTabs';

const DispatchColorSetting = () => {
  const [showAddModal, setShowAddModal] = useState(false);

  const handleShowAddModal = (event) => {
    setShowAddModal(true);
  };

  const handleHideAddModal = (event) => {
    setShowAddModal(false);
  };

  return (
    <div className="position-relative subheader-wrapper">
      <div className="subheader">
        <div className="subheader__inner d-flex align-items-center py-0">
          <SettingsTab
            activeTab={9}
            button={
              <div className="d-flex">
                <button className="mr-2 btn btn-outline-light ">
                  <IconDownload className="mr-2" />
                  Downlaod CVS
                </button>
                <button
                  className=" btn btn-success "
                  onClick={handleShowAddModal}
                >
                  <IconPlus className="mr-2" />
                  Add Commodity
                </button>
              </div>
            }
          />
        </div>
      </div>
      <div className="page-fluid">
        <h1>Design not yet in figma</h1>
      </div>
    </div>
  );
};

export default DispatchColorSetting;
